import { Box, Typography } from "@mui/joy";
import { ClassicyControlGroup } from "../../components/control-group/ClassicyControlGroup";
import "../styles/QuestionnaireSteps.css";

interface ColorSelectionStepProps {
  selectedColor: string | null;
  onSelect: (color: string) => void;
}

const IMAC_COLORS = [
  { name: "Bondi Blue", displayName: "Bondi Blau", hex: "#43aaaa" },
  { name: "Blueberry", displayName: "Blueberry", hex: "#169eb1" },
  { name: "Lime", displayName: "Lime", hex: "#4a8a30" },
  { name: "Strawberry", displayName: "Strawberry", hex: "#76192e" },
  { name: "Grape", displayName: "Grape", hex: "#37005e" },
  { name: "Tangerine", displayName: "Tangerine", hex: "#803e00" },
  { name: "Other color", displayName: "Andere Farbe", hex: "#CCCCCC" },
];

function ColorSelectionStep({
  selectedColor,
  onSelect,
}: ColorSelectionStepProps) {
  return (
    <Box className="questionnaire-step">
      <Typography level="h2" sx={{ mb: 3, textAlign: "center" }}>
        In welcher Farbe erinnerst du dich an den iMac G3?
      </Typography>

      <ClassicyControlGroup label="Farbe auswählen" columns={false}>
        <Box className="color-grid">
          {IMAC_COLORS.map((color) => (
            <button
              key={color.name}
              className={`color-button ${selectedColor === color.name ? "selected" : ""}`}
              onClick={() => onSelect(color.name)}
              style={{
                backgroundColor: color.hex,
                border:
                  selectedColor === color.name
                    ? "4px solid #000"
                    : "2px solid #ccc",
              }}
              aria-label={`${color.displayName} auswählen`}
            >
              <span className="color-name">{color.displayName}</span>
            </button>
          ))}
        </Box>
      </ClassicyControlGroup>
    </Box>
  );
}

export default ColorSelectionStep;
